import ExtensionIcon from '@material-ui/icons/Extension';
import CrosswordsCreate from './components/CrosswordsCreate';
import CrosswordsEdit from './components/CrosswordsEdit';
import { APP_TYPES, roles } from '../../config/constants';
import CrosswordsList from './components/CrosswordsList';

const options = {
  appTypes: [APP_TYPES.HUNGARY],
  allowedRoles: [roles.ADMIN],
  label: 'Crosswords',
};

export default {
  create: CrosswordsCreate,
  list: CrosswordsList,
  edit: CrosswordsEdit,
  icon: ExtensionIcon,
  name: 'admin/crosswords',
  options,
};
